import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';

const ProtectedRoute = ({ children }) => {
  const { isLoaded, isSignedIn } = useAuth();
  const location = useLocation();

  if (!isLoaded) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 'calc(100vh - 49px)', background: 'var(--bg-primary)' }}>
        <div className="loading-spinner" />
      </div>
    );
  }

  if (!isSignedIn) {
    // Signup, not sign-in: almost everyone hitting a gated URL from the
    // marketing site does not have an account yet. Returning users still
    // have Sign in on that page. Keep the path so Clerk can send them
    // back to the episode they actually clicked.
    const next = `${location.pathname}${location.search}`;
    return (
      <Navigate
        to={`/signup?redirect_url=${encodeURIComponent(next)}`}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;
